<div class="unread-badge-wrapper" [class.static]="static">
    <ng-content></ng-content>
    <ion-badge
        *ngIf="showBadge && variant === 'count'"
        class="unread-badge"
        [style.top]="!static ? top : null"
        [style.right]="!static ? right : null"
        [style.bottom]="!static ? bottom : null"
        [style.left]="!static ? left : null"
    >
        {{ count > 9 ? "9+" : count }}
    </ion-badge>
    <span
        *ngIf="showBadge && variant === 'dot'"
        class="unread-badge-dot"
        [style.top]="!static ? top : null"
        [style.right]="!static ? right : null"
        [style.bottom]="!static ? bottom : null"
        [style.left]="!static ? left : null"
    ></span>
</div>
